export const listProducts = (state) => state.listProducts;
export const loading = (state) => state.loading;
export const fieldProducts = (state) => state.fieldProducts;
export const pagination = (state) => (state.pagination);
